import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Code block — file/lang label, copy button, basic syntax tinting via
// react-syntax-highlighter (already a packages/ui dep) so the look
// matches the rest of the app's code rendering.
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { useState } from "react";
import { Icon } from "./icons.js";
export function CodeBlock({ lang = "text", filename, children }) {
    const [copied, setCopied] = useState(false);
    const code = String(children ?? "");
    const onCopy = () => {
        navigator.clipboard?.writeText(code).catch(() => undefined);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1400);
    };
    return (_jsxs("div", { className: "code", children: [_jsxs("div", { className: "code__head", children: [_jsx("span", { className: "lang", children: filename ?? lang }), _jsxs("button", { type: "button", className: `code__copy${copied ? " copied" : ""}`, onClick: onCopy, children: [copied ? _jsx(Icon.check, {}) : _jsx(Icon.copy, {}), copied ? "copied" : "copy"] })] }), _jsx(SyntaxHighlighter, { language: normalizeLang(lang), style: vscDarkPlus, customStyle: { margin: 0, padding: 12, background: "transparent", fontSize: "var(--fs-code)" }, codeTagProps: { style: { fontFamily: "var(--mono)" } }, wrapLongLines: true, children: code })] }));
}
// react-syntax-highlighter's Prism build wants long names ("javascript",
// "typescript", "python", "bash") — the mockup happily used short codes
// like "js" / "ts" / "py" / "sh". Normalize to keep both inputs working.
function normalizeLang(lang) {
    switch (lang) {
        case "js":
            return "javascript";
        case "ts":
            return "typescript";
        case "py":
            return "python";
        case "sh":
            return "bash";
        default:
            return lang || "text";
    }
}
//# sourceMappingURL=CodeBlock.js.map